<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Tipos de cuenta
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Tipos de cuentas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="showModalAgregar(); showNew();" size="sm" mdbWavesEffect>Agregar</button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px;">
        <div class="md-form">
          <input value="" type="text" id="buscar" class="form-control" [(ngModel)]="nombre" placeholder="Buscar" required #buscar />
          <label for="vecodigo">Buscar</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="obtenerDatosSegunFiltro(nombre)" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Descripción</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!tipocuentaList || tipocuentaList.length === 0">
            <td colspan="3" style="text-align: center;">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let tipc of tipocuentaList">
            <td>{{ tipc.nombre }}</td>
            <td>
              <div *ngIf="tipc.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!tipc.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" (click)="showForEdit(tipc); showModalModificar()" mdbTooltip="Editar" placement="right"><mdb-icon fas icon="pen"></mdb-icon></button>
              <button *ngIf="!tipc.activado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect (click)="permitirCambioEstado(tipc)" mdbTooltip="Activar" placement="right"><mdb-icon fas icon="ban"></mdb-icon></button>
              <button *ngIf="tipc.activado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect (click)="permitirCambioEstado(tipc)" mdbTooltip="Desactivar" placement="right"><mdb-icon fas icon="check"></mdb-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar rol -->
<div mdbModal #agregarTipoCuenta="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
    <form [formGroup]="formulario" (ngSubmit)="insertar(); agregarTipoCuenta.hide();">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="agregarTipoCuenta.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Datos de tipo de cuenta
            </h5>
          </div>
          <div class="col">
            <div class="switch info-switch">
              <label
                >Inactivo<input
                  formControlName="activado"
                  type="checkbox"
                  color="info"
                  checked=""
                /><span class="lever"></span> Activo
              </label>
            </div>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" formControlName="nombre" type="text" id="anombre" class="form-control" placeholder="Descripción" required #anombre />
              <label for="nombre">Descripción</label>
              <div *ngIf="formulario.get('nombre').invalid && (formulario.get('nombre').dirty || formulario.get('nombre').touched)">
                <mdb-error *ngIf="formulario.get('nombre').hasError('required')">La Descripción es requerido.</mdb-error>
                <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">La Descripción no puede superar los 50 caracteres.</mdb-error>
                <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">La Descripción debe tener como mínimo 5 caracteres.</mdb-error>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
          (click)="agregarTipoCuenta.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="submit" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="formulario.invalid">
          Guardar
        </button>
      </div>
    </form>
    </div>
  </div>
</div>

  <!-- MODAL Editar rol -->
<div mdbModal #editarTipoCuenta="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
  <form [formGroup]="formulario" (ngSubmit)="actualizar(); editarTipoCuenta.hide();">
    <div class="modal-header">
      <h4 class="modal-title w-100 text-left" id="myModalLabel">
        Agregar
      </h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="editarTipoCuenta.hide()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <h5 class="modal-title w-100 text-left" id="myModalLabel">
            Datos de tipo de cuenta
          </h5>
        </div>
        <div class="col">
          <div class="switch info-switch">
            <label
              >Inactivo<input
                formControlName="activado"
                type="checkbox"
                color="info"
                checked=""
              /><span class="lever"></span> Activo
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="md-form">
            <input value="" formControlName="nombre" type="text" id="enombre" class="form-control" placeholder="Descripción" required #enombre />
            <label for="nombre">Descripción</label>
            <div *ngIf="formulario.get('nombre').invalid && (formulario.get('nombre').dirty || formulario.get('nombre').touched)">
              <mdb-error *ngIf="formulario.get('nombre').hasError('required')">La Descripción es requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">La Descripción no puede superar los 50 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">La Descripción debe tener como mínimo 5 caracteres.</mdb-error>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarTipoCuenta.hide()" mdbWavesEffect>Cerrar</button>
      <button  type="submit" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="formulario.invalid">Guardar</button>
    </div>
  </form>
  </div>
</div>
</div>